import type { ReactElement } from 'react';
import { TbUserCheck } from 'react-icons/tb';

export interface HandoffBlockPayload {
  status: 'waiting' | 'active';
  lead_name?: string;
  agent_name?: string;
  /** Usado pelo painel para assinar o canal realtime (nao renderizado). */
  conversation_id?: string;
}

/** Card mostrado no widget quando a conversa entra na fila do time comercial. */
export function HandoffBlock({ payload }: { payload: HandoffBlockPayload }): ReactElement {
  const waiting = payload.status === 'waiting';
  return (
    <div className="border-violet/30 bg-violet/10 flex items-start gap-3 rounded-2xl border px-4 py-3">
      <span className="bg-violet/20 text-violet mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full">
        <TbUserCheck size={16} strokeWidth={1.9} />
      </span>
      <div className="min-w-0">
        <p className="text-ink text-sm font-semibold">
          {waiting ? 'Você está na fila do time comercial' : 'Time comercial conectado'}
        </p>
        <p className="text-ink-muted mt-0.5 text-xs leading-relaxed">
          {waiting
            ? 'Alguém do time da Trakd já te responde por aqui mesmo. Pode continuar mandando mensagem.'
            : payload.agent_name
              ? `${payload.agent_name} assumiu a conversa.`
              : 'Um atendente assumiu a conversa.'}
        </p>
      </div>
    </div>
  );
}
